<div class="login-portal">

    <div style="font-size:1.4em; font-weight:600; margin-bottom:0.2em;">
        {{fullName}}
    </div>
    <div style="font-size:1.1em; margin-bottom: 2em">
        <tra-md slug="txt_login_portal_instr"></tra-md>
    </div>

    <div class="portal-link-mosaic">
        <div *ngFor="let accountType of accountTypes" [style.background-color]="accountType.color" class="portal-link">
            <div class="login-notification" *ngIf="getTotalNotificationCount(accountType) > 0">
                <div class="notification-bubble">
                    {{ getTotalNotificationCount(accountType) }}
                </div>
            </div>
            <!-- Profile completion warning OR a new (unviewed) task invitation -->
            <div class="profile-warning" *ngIf="shouldShowProfileWarning(accountType) || shouldShowTaskWarning(accountType)"
                 [title]="getPortalWarningTooltip(accountType)">
                <div class="warning-exclamation">
                    <i class="fa fa-exclamation"></i>
                </div>
            </div>
            <!-- TEST-001 — one link per account the person holds, keyed by account type, so a test picks the role it needs. -->
            <a [href]="accountType.route" data-testid="login-portal-link" [attr.data-account-type]="accountType.account_type" [class.disabled-link] = "showConfirmBtn(accountType)" (click)="storeCurrentAccountType(accountType)">
                <tra [slug]="accountType.caption"></tra>
                <div style="font-weight:400;">
                    <span *ngIf="accountType.s_name">
                        {{accountType.s_name}} ({{accountType.s_foreign_id}})
                    </span>
                    <span *ngIf="accountType.sd_name">
                        {{accountType.sd_name}} ({{accountType.sd_foreign_id}})
                    </span>
                </div>
            </a>
            <div *ngIf="showConfirmBtn(accountType)" class="pre-button-strip">
                <button class = 'confirm' (click)="confirmBtnClick(accountType)"><tra slug="lp-button-confirm"></tra></button>
                <button class = 'not-my-school' (click)="notMySchoolBtnClick(accountType)"><tra [slug]="getNotMyInstitutionSlug(accountType.account_type)"></tra></button>
            </div>
        </div>
    </div>
</div>